/*
Polyfill Number.isInteger for IE (all versions)
http://caniuse.com/#feat=es6-number
 */

if (!Number.isInteger) {
  Number.isInteger = value => (typeof value === 'number' && isFinite(value) && Math.floor(value) === value);
}



// WEBPACK FOOTER //
// ./src/modules-es5/commons/polyfills/numbers.js